export default __webpack_public_path__ + "static/p6-7d36e93dab8f9745dc0d0274f070a3c9.jpg";